import APIClient from '@/libraries/api-client'

class Game extends APIClient {

}

export default Game